export default "__VITE_ASSET__C1ds5Q0w__"